import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const Wrapper = styled.p`
  margin-bottom: 0;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  cursor: pointer;
  position: relative;
  margin-bottom: 0;

  &[data-show-tooltip="true"]:hover::after {
    content: attr(data-fulltext);
    position: absolute;
    left: 0;
    top: 100%;
    z-index: 100;
    background-color: #333;
    color: #fff;
    padding: 8px 10px;
    border-radius: 6px;
    white-space: pre-wrap;
    max-width: 400px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    font-size: 12px;
    line-height: 1.4;
    opacity: 0;
    animation: fadeIn 0.2s ease-in-out forwards;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

interface Props {
  text?: string | number | null;
}

export const TruncatedText: React.FC<Props> = ({ text }) => {
  const ref = useRef<HTMLParagraphElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const isOverflowing = el.scrollHeight > el.clientHeight + 1;
    setIsTruncated(isOverflowing);
  }, [text]);

  const displayText =
    text && text.toString().trim().length > 0 ? text.toString() : "-";

  return (
    <Wrapper
      ref={ref}
      data-show-tooltip={isTruncated}
      data-fulltext={displayText}
      title={isTruncated ? displayText : undefined} // fallback native tooltip
    >
      {displayText}
    </Wrapper>
  );
};